/**
 * -- MAIN.JS --
 * This file is the main entry point for Vite.
 * It imports the main SCSS file for all compiled CSS.
 * This theme includes AlpineJS for interactivity.
 */

import 'vite/modulepreload-polyfill';
import './styles/main.scss';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
// import htmx from 'htmx.org'; // Commented out - not currently used
import './js/noise-component.js';

// Alpine JS
window.Alpine = Alpine;
Alpine.plugin(collapse);
import './js/alpine-stores';
import './js/events-archive.js';
import { initTickerSpeed } from './js/ticker-speed.js';
Alpine.start();

// HTMX - Commented out since not currently used
// window.htmx = htmx;

// DOM Ready
document.addEventListener('DOMContentLoaded', () => {
  initTickerSpeed();
  // Consolidated ResizeObserver for better performance
  const elementsToObserve = [
    {
      selector: '.c-header-wrapper',
      callback: (entry) => {
        document.documentElement.style.setProperty(
          '--header-height',
          `${entry.contentRect.height}px`
        );
      }
    },
    {
      selector: '.c-hero__image',
      callback: (entry) => {
        const heroImage = entry.target;
        heroImage.style.marginBottom = `-${entry.contentRect.height / 2}px`;
        heroImage.closest('.c-hero').style.marginBottom = `${entry.contentRect.height / 2}px`;
      }
    }
  ];

  const consolidatedObserver = new ResizeObserver((entries) => {
    entries.forEach(entry => {
      const element = elementsToObserve.find(item => 
        entry.target.matches(item.selector)
      );
      if (element) {
        element.callback(entry);
      }
    });
  });

  elementsToObserve.forEach(({ selector }) => {
    const element = document.querySelector(selector);
    if (element) {
      consolidatedObserver.observe(element);
    }
  });
});